import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskedLines, Reveal, Overline } from "./shared";
import { LightArt } from "./LightArt";

const LINES = [
    "Architecture doesn't have to stand still.",
    "Motion can become art.",
    "Light can become an experience.",
    "Technology can disappear behind beauty.",
];

export const Philosophy = () => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const artY = useTransform(scrollYProgress, [0, 1], [80, -80]);

    return (
        <section ref={ref} data-testid="philosophy-section" className="relative overflow-hidden py-32 md:py-48 lg:py-64">
            <motion.div style={{ y: artY }} className="pointer-events-none absolute -right-24 top-1/2 hidden h-[70vh] w-[38vw] -translate-y-1/2 opacity-60 lg:block">
                <LightArt variant="rods" hue="mixed" className="h-full w-full" />
            </motion.div>
            <div className="relative mx-auto max-w-[1400px] px-6 md:px-12">
                <Overline>The Core Idea</Overline>
                <h2 className="mt-10 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight sm:text-6xl lg:text-8xl">
                    <MaskedLines lines={["What if your", "space could move?"]} />
                </h2>
                <div className="mt-20 max-w-2xl space-y-8 md:mt-28">
                    {LINES.map((l, i) => (
                        <Reveal key={i} delay={i * 0.1}>
                            <p className="border-l border-white/15 pl-6 text-lg font-light leading-relaxed tracking-wide text-white/65 md:text-xl">
                                {l}
                            </p>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
